var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-header row no-gutters align-items-center" },
      [
        _c("div", { staticClass: "col-9" }, [
          _c("h4", { staticClass: "regular s-bold text-light-gray ali" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("settings.themeTab.theme")) +
                "\n      "
            ),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "regular text-light-gray" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.customizeMessageBySettingsType) +
                "\n      "
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-block p-4" },
      [
        _c(
          "b-row",
          { staticClass: "justify-content-center" },
          _vm._l(_vm.themes, function (theme) {
            return _c(
              "b-col",
              {
                key: theme.value,
                staticClass: "theme-option my-2",
                attrs: { cols: "10", lg: "4", sm: "6" },
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: _vm.getThemeImg(theme), alt: theme.value },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "mb-md-0 mb-4 mt-3" }, [
                  _c("div", { staticClass: "pretty p-default p-round" }, [
                    _c("input", {
                      attrs: {
                        id: theme.value + "-id",
                        type: "radio",
                        name: "theme-radio",
                      },
                      domProps: {
                        checked: _vm.isThemeChecked(theme.value),
                        value: theme.value,
                      },
                      on: { change: _vm.handleChangeTheme },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { attrs: { for: theme.value + "-id", hidden: "" } },
                      [_vm._v(_vm._s(theme.label))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "state p-primary" }, [
                      _c("label", [_vm._v(_vm._s(theme.label))]),
                    ]),
                  ]),
                ]),
              ]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-3 pt-2 px-3 column-divider-top" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mb-lg-0 mb-3",
                    attrs: { cols: "12", lg: "4" },
                  },
                  [
                    _c("b-row", { staticClass: "mb-md-0 mb-4 mt-3" }, [
                      _c("div", { staticClass: "pretty p-default p-round" }, [
                        _c("input", {
                          attrs: {
                            id: "own-theme-id",
                            type: "radio",
                            name: "theme-radio",
                            value: "custom",
                          },
                          domProps: { checked: _vm.isThemeChecked("own") },
                          on: { change: _vm.handleChangeTheme },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: "own-theme-id", hidden: "" } },
                          [_vm._v("Own")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "state p-primary" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("settings.themeTab.selectYourOwnColors")
                              )
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12", lg: "4", sm: "6" } }, [
                  _c(
                    "div",
                    { staticClass: "form-group theme-colorpicker" },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "extra-small text-light-gray text-uppercase",
                        },
                        [_vm._v(_vm._s(_vm.$t("global.words.primary")))]
                      ),
                      _vm._v(" "),
                      _c("colorpicker", {
                        attrs: { color: _vm.currentTheme.primary },
                        on: {
                          "update:color": function ($event) {
                            return _vm.$set(_vm.currentTheme, "primary", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.currentThemeIsCustom
                    ? _c("div", { staticClass: "overlay clear" })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12", lg: "4", sm: "6" } }, [
                  _c(
                    "div",
                    { staticClass: "form-group theme-colorpicker" },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "extra-small text-light-gray text-uppercase",
                        },
                        [_vm._v(_vm._s(_vm.$t("global.words.secondary")))]
                      ),
                      _vm._v(" "),
                      _c("colorpicker", {
                        attrs: { color: _vm.currentTheme.secondary },
                        on: {
                          "update:color": function ($event) {
                            return _vm.$set(
                              _vm.currentTheme,
                              "secondary",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.currentThemeIsCustom
                    ? _c("div", { staticClass: "overlay clear" })
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }